<template>
    <div :class="['bxs-menu', {
        'bxs-menu-on': local_on,
        'bxs-menu-block': block
    }]">
        <!-- activator -->
        <div
        v-if="!!$slots.activator && !solo"
        class="bxs-menu--activator">
            <slot
            name="activator"
            :value="local_on"
            :on="{
                click: () => local_on = !local_on
            }"
            :attrs="{
                role: 'button',
                'aria-haspopup': true,
                'aria-expanded': false
            }" />
        </div>

        <div v-else-if="!$slots.activator && !solo">
            <c-btn
            v-bind="activatorProps"
            @click="open">
            </c-btn>
        </div>

        <!-- content -->
        <Teleport to="body">
            <div
            ref="menu"
            :class="['bxs-menu--menu', { 'bxs-menu--menu-on': local_on }]"
            @click.self="handleClickForeground">
                <div class="bxs-menu--menu--content bxs-elevation ma-0 pa-0">
                    <div
                    ref="header"
                    class="bxs-menu--menu--content--header">
                        <p
                        v-if="title"
                        class="ma-0 text-mute">{{ title }}</p>

                        <slot name="header" />

                        <svg
                        class="bxs-pointer"
                        viewBox="0 0 20 20"
                        width="30px"
                        height="30px"
                        fill="#000"
                        @click="close">
							<path fill="none" d="M15.898,4.045c-0.271-0.272-0.713-0.272-0.986,0l-4.71,4.711L5.493,4.045c-0.272-0.272-0.714-0.272-0.986,0s-0.272,0.714,0,0.986l4.709,4.711l-4.71,4.711c-0.272,0.271-0.272,0.713,0,0.986c0.136,0.136,0.314,0.203,0.492,0.203c0.179,0,0.357-0.067,0.493-0.203l4.711-4.711l4.71,4.711c0.137,0.136,0.314,0.203,0.494,0.203c0.178,0,0.355-0.067,0.492-0.203c0.273-0.273,0.273-0.715,0-0.986l-4.711-4.711l4.711-4.711C16.172,4.759,16.172,4.317,15.898,4.045z"></path>
						</svg>
                    </div>

                    <div
                    ref="scroller"
                    class="bxs-menu--menu--content--body bxs-scrollable">
                        <slot />
                    </div>

                    <div
                    ref="footer"
                    class="bxs-menu--menu--content--footer py-4">
                        <!-- <bxs-list-item
                        v-if="closable && !solo"
                        prepend-icon="close"
                        @click="close">Chiudi</bxs-list-item> -->

                        <slot name="actions" />
                    </div>
                </div>
            </div>
        </Teleport>
    </div>
</template>

<script>
export default {
    name: 'bxs-menu',
    props: {
        modelValue: {
            type: Boolean,
            required: false,
            default: false
        },
        title: {
            type: String,
            required: false,
            default: null
        },
        'max-width': {
            type: [String, Number],
            required: false,
            default: '440px'
        },
        'min-height': {
            type: [String, Number],
            required: false,
            default: null
        },
        'activator-props': {
            type: Object,
            required: false,
            default: null
        },
        'activator-icon': {
            type: String,
            required: false,
            default: 'three-dots'
        },
        solo: {
            type: Boolean,
            required: false,
            default: false
        },
        'close-on-click': {
            type: Boolean,
            required: false,
            default: false
        },
        closable: {
            type: Boolean,
            required: false,
            default: true
        },
        block: {
            type: Boolean,
            required: false,
            default: false
        }
    },
    emits: [
        'update:modelValue',
        'open',
        'close',
        'infinite-scroll'
    ],
    data () {
        return {
            local_on: false,
            body_h: 0
        }
    },
    mounted () {
        this.$nextTick(this.play)
    },
    watch: {
        local_on (newVal) {
            if (newVal) {
                this.$emit('open')

                this.$nextTick(() => {
                    if (this.$refs.scroller) {
                        this.$refs.scroller.addEventListener('scroll', this.handleScroll)
                    }
                })
            } else {
                this.$emit('close')

                if (this.$refs.scroller) {
                    this.$refs.scroller.removeEventListener('scroll', this.handleScroll)
                }
            }

            this.$emit('update:modelValue', newVal)
        },
        modelValue (newVal) {
            this.local_on = newVal
        }
    },
    methods: {
        play () {
            if (this.$refs.scroller) {
                this.$refs.scroller.addEventListener('scroll', this.handleScroll)
            }

            if (this.closeOnClick) {
                window.addEventListener('click', this._checkClose)
            }

            this.resize()
        },
        resize () {
            let h = this.$refs.header.clientHeight
            if (this.$refs.footer) h += this.$refs.footer.clientHeight
            this.body_h = (this.$refs.scroller.clientHeight - h) + 'px'
        },
        stop () {
            if (this.$refs.scroller) {
                this.$refs.scroller.removeEventListener('scroll', this.handleScroll)
            }

            if (this.closeOnClick) {
                window.removeEventListener('click', this.checkClose)
            }
        },
        handleScroll () {
            if (!this.$refs.scroller) return

            const {
                scrollTop,
                scrollHeight,
                clientHeight
            } = this.$refs.scroller

            // console.log(scrollTop + clientHeight, clientHeight, scrollHeight)

            if (
                scrollTop + clientHeight >= (scrollHeight - (clientHeight / 2))
            ) {
                this.$emit('infinite-scroll')
            }
        },
        _checkClose (e) {
            if (!this.$el.contains(e.target)) {
                // console.log('Clicked outside l2 and logo-menu')
                this.local_on = false
            }
        },
        handleClickForeground () {
            this.close()
        },
        open () {
            this.local_on = true
            console.log('menu open', this.local_on)
        },
        close () {
            this.local_on = false
        }
    },
    beforeUnmount () {
        this.stop()
    }
}
</script>

<style lang="scss" scoped>
@import '@/assets/styles/mq.scss';

.menu-enter-active,
.menu-leave-active {
    transition: transform 0.2s ease-out;
}

.menu-enter-from,
.menu-leave-to {
    transform: translateY(100%);
}

.bxs-menu {
    position: relative;
    display: inline-block;
    vertical-align: middle;
    text-align: left;
    overflow: hidden;

    &.bxs-menu-block {
        display: block;
    }

    &--activator {
    }

    &--menu {
        position: fixed;
        width: 100%;
        height: 100vh;
        height: calc(var(--vh, 1vh) * 100);
        top: 0;
        left: 0;
        -webkit-backdrop-filter: var(--menu-foreground-backdrop-filter);
        backdrop-filter: var(--menu-foreground-backdrop-filter);

        display: flex;
        flex-flow: column nowrap;
        justify-content: flex-end;

        z-index: var(--layer-menu);
        overflow: hidden;

        // trans
        pointer-events: none;
        transition: background-color 0.2s ease;

        @include mq($mq-static-breakpoint) {
            justify-content: flex-start;
            align-items: flex-end;

            > .bxs-layout {
                margin-right: 0;
            }
        }

        &.bxs-menu--menu-on {
            pointer-events: inherit;
            background-color: var(--menu-foreground-background-color);

            .bxs-menu--menu--content {
                transform: translateY(0);

                @include mq($mq-static-breakpoint) {
                    transform: translateX(0);
                }
            }
        }

        &--content {
            width: 100%;
            max-width: 440px;
            flex: 1 1 auto;

            position: relative;
            display: flex;
            flex-direction: column;
            background-color: var(--menu-content-background-color);
            padding: var(--menu-content-padding-y) var(--menu-content-padding-x);
            overflow: hidden;

            transform: translateY(100%);
            transition: transform 0.28s ease-out;

            @include mq($until: $mq-static-breakpoint) {
                max-width: 100% !important;
                max-height: 95%;
                border-radius: var(--menu-content-border-radius);
            }

            // desktop
            @include mq($mq-static-breakpoint) {
                border-top-right-radius: 0;
                height: 100% !important;
                transform: translateX(100%);
            }

            &--header {
                position: relative;
                display: flex;
                flex-flow: row nowrap;
                align-items: center;
                justify-content: space-between;
                min-height: var(--navbar-min-height);
                padding-left: var(--size-layout);
                padding-right: var(--size-layout);
                padding-top: var(--navbar-padding-y);
                padding-bottom: var(--navbar-padding-y);

                @include mq($until: $mq-static-breakpoint) {
                    &::before {
                        content: "";
                        position: absolute;
                        top: calc(var(--size-ui) / 2);
                        left: 0;
                        right: 0;
                        margin: auto;
                        width: 40px;
                        height: 4px;
                        border-radius: 4px;
                        background-color: var(--divider-color);
                    }
                }
            }

            &--body {
                position: relative;
                flex: 1;
                background-color: var(--menu-content-background-color);
                // padding-left: var(--size-layout);
                // padding-right: var(--size-layout);
            }

            &--footer {
                position: relative;
                overflow: hidden;
                margin-top: auto;
                background-color: var(--menu-content-background-color);
                min-height: var(--navbar-min-height);

                &::before {
                    content: "";
                    position: absolute;
                    top: 0;
                    left: 0;
                    width: 100%;
                    height: 1px;
                    background-color: var(--divider-color);
                }
            }
        }
    }
}
</style>